/**
 * Préférences scalaires admin (subset des préférences user).
 *
 * Admin ne touche QUE :
 *  - `preferredLocale` (BCP-47, contrat backend `fr-FR` / `en-US`)
 *  - `theme` (LIGHT / DARK / SYSTEM)
 *
 * Les champs `profileVisibility` / `allowMessaging` existent côté backend mais
 * ne sont pas pertinents dans l'admin : ils sont conservés pour parser la
 * réponse sans perte et renvoyés tels quels lors d'un PATCH partiel (jamais
 * envoyés depuis l'UI admin).
 */

export const Theme = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  SYSTEM: 'SYSTEM',
} as const;
export type Theme = (typeof Theme)[keyof typeof Theme];

export const SUPPORTED_BCP47_LOCALES = ['fr-FR', 'en-US'] as const;
export type Bcp47Locale = (typeof SUPPORTED_BCP47_LOCALES)[number];

export interface UserPreferences {
  preferredLocale: Bcp47Locale;
  theme: Theme;
  /** Champs non éditables depuis l'admin — conservés pour PATCH partiel. */
  profileVisibility?: string;
  allowMessaging?: string;
}

export type UpdateUserPreferencesPayload = Partial<
  Pick<UserPreferences, 'preferredLocale' | 'theme'>
>;

export const DEFAULT_PREFERENCES: UserPreferences = {
  preferredLocale: 'fr-FR',
  theme: Theme.SYSTEM,
};
